///<reference path="../common/strategy-api-base.ts"/>


module Meevo.Components.Controls.SmartMover {
  import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

  import IReportManufacturers = Meevo.Plugins.Reports.IReportManufacturers;
  import IReportProductCategory = Meevo.Plugins.Reports.IReportProductCategory;
  import MeevoMap = Meevo.Components.Common.MeevoMap;

  interface IRes {
    manufacturerIds: string[];
    id: string;
    objectState: ObjectStateEnum;
    displayName: string;
    homeLocationId: number;
  }

  export class ManufacturersProdCatStrategy extends StrategyApiBase<IRes> implements ICollectionPopulate {
    protected manufactures: MeevoMap<string>;

    constructor(
      manufacturers: IApiCollection<IReportManufacturers>,
      productCategories: IApiCollection<IReportProductCategory>,
      dataService: Meevo.Components.BaseClasses.IDataService,
      options: { criteria: _.Dictionary<any> }
    ) {
      super(manufacturers, productCategories, dataService, {
        url: '/Report/ProductCategory/Manufacturer',
        criteria: {
          businessTypeList: null,
          locationList: null,
          hierarchyId: null,
          branchId: null,
          objectStateEnumList: [ObjectStateEnum.Active],
          displayName: null,
          fieldOrderBy: 'DisplayName',
          orderAscDesc: 'Ascending',
          ...options.criteria
        }
      });

      this.manufactures = new MeevoMap<string>();
    }

    protected fetch(): angular.IPromise<IRes[]> {
      return super.fetch()
        .then(() => {
          for (const row of this.result) {
            for (const manufacturerId of row.manufacturerIds) {
              this.manufactures.add(manufacturerId, row.id);
            }
          }

          return this.result;
        });
    }

    populateData(): void {
      if (this.parent.models.length === 0) {
        return;
      }

      for (const manufacturer of this.parent.models) {
        (<ISmartMoverCategoryModel<IReportManufacturers>>manufacturer).resetModels(
          this.child
            .models
            .filter((category) => {
              const manufacture = this.manufactures.get(manufacturer.id);

              if (!manufacture) return false;

              return this.manufactures.get(manufacturer.id).indexOf(category.id) !== -1
            })
        );
      }
    }
  }
}
